import {Routes} from "react-router";
import {Route} from "react-router-dom";
import ProviderSearchResults from "./Map/ProviderSearchResults";
import React from "react";
import {Error404} from "./Error404";
import {ArticleView} from "./ArticleView/ArticleView";
import {Dashboard} from "./Dashboard/Dashboard";
import {Confirmation} from "./BookingFlow/Confirmation";
import {BookingFlow} from "./BookingFlow/BookingFlow";
import {StripeCallback} from "./BookingFlow/StripeCallback";
import {PolicyPage} from "./Policy/PolicyPage";
import {Index} from "./Index/Index";
import {Home} from "./Home/Home";
import {Library} from "./Library/Library";

/**
 * Top level app router. Most of these pages allow the user to be logged in or out,
 * with or without a profile. This is handled within the pages themselves.
 */
export const AppRouter = () => {

  return <Routes>
    <Route path="/" element={<Index/>}/>
    <Route path="/home" element={<Home/>}/>
    <Route path="/book" element={<BookingFlow/>}/>

    <Route path="/stripe-callback" element={<StripeCallback/>}/>
    <Route path="/confirmation" element={<Confirmation/>}/>
    <Route path="/library" element={<Library/>}/>
    <Route path="/library/article/:articleId" element={<ArticleView/>}/>
    <Route path='/search' element={<ProviderSearchResults/>}/>
    <Route path='/dashboard/*' element={<Dashboard/>}/>


    <Route path={'/consumer_tos'} element={<PolicyPage documentPath={require('./Policy/consumer_tos.md')}/>}/>
    <Route path={'/cookies_policy'} element={<PolicyPage documentPath={require('./Policy/cookies_policy.md')}/>}/>
    <Route path={'/privacy_policy'} element={<PolicyPage documentPath={require('./Policy/privacy_policy.md')}/>}/>
            
    <Route path="*" element={<Error404/>}/>
  </Routes>
}